import script from "./ConsumptionChannelList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumptionChannelList.vue?vue&type=script&setup=true&lang=js"

import "./ConsumptionChannelList.vue?vue&type=style&index=0&id=b4a003be&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4a003be"]])

export default __exports__